import Pencil from 'assets/icons/fa/pen.svg'

Pencil.displayName = 'Pencil'
export default Pencil
